import React from 'react'
import { Search, X, RefreshCw } from 'lucide-react'
import { Tooltip } from '../ui'

interface Props {
  value: string
  onChange: (v: string) => void
  placeholder: string
  onRefresh: () => void
  refreshing: boolean
  refreshLabel: string
  /** Anything the page wants between the search box and the refresh button. */
  children?: React.ReactNode
}

/**
 * Search + refresh, in the shape PostsTable established: search left, actions
 * right, clear button inside the field.
 */
const BroadcastToolbar: React.FC<Props> = ({
  value, onChange, placeholder, onRefresh, refreshing, refreshLabel, children
}) => (
  <div className="flex items-center justify-between gap-4">
    <div className="relative">
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-gray-400" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-8 pr-8 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-64"
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
          aria-label="Clear search"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
    <div className="flex items-center gap-2">
      {children}
      <Tooltip content={refreshLabel} placement="top">
        <button
          onClick={onRefresh}
          disabled={refreshing}
          className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors disabled:opacity-40"
        >
          <RefreshCw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
        </button>
      </Tooltip>
    </div>
  </div>
)

export default BroadcastToolbar
